module.exports = __webpack_public_path__ + "static/media/sopt4ru.f8d3dfa0.pdf";